// The app's API client singleton (FR-033, FR-035, FR-036; contracts/session-seam.md §4), wired to
// the runtime configuration and the session controller: authFetch attaches the access token, renews
// before it expires and once after a 401 (002, FR-021). A 401 that survives the renewal is returned
// to the caller; the controller has already signed out if the session ended.
import { appSessionController } from "@/session/SessionProvider";

import { createAuthFetch } from "./authFetch";
import { configuredBaseUrl } from "./baseUrl";
import { createApiClient } from "./client";

export const api = createApiClient({
  baseUrl: configuredBaseUrl(),
  fetch: createAuthFetch({
    fetch: (request) => fetch(request),
    session: appSessionController,
  }),
  session: {
    getAccessToken: () => appSessionController.getAccessToken(),
    onUnauthenticated: () => {},
  },
});

export { toAppError, isAppError, type AppError } from "./errors";
export { unwrap, createApiClient } from "./client";
